import { apiClient } from "../../../api/client";
import * as ActionType from "./fakeReels.type";

export const getFakeReels = () => async (dispatch) => {
  const res = await apiClient.get("reels/getFakeReels");
  if (res.ok) {
    dispatch({ type: ActionType.GET_FAKE_REELS, payload: res.data?.reels });
  } else {
    console.error(res.message);
  }
};

export const createFakeReel = (data) => async (dispatch) => {
  const res = await apiClient.post("reels/createFakeReel", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_FAKE_REELS, payload: res.data?.reel });
  } else {
    console.error(res.message);
  }
};

export const updateFakeReel = (data) => async (dispatch) => {
  const res = await apiClient.patch("reels/updateFakeReel", data);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_FAKE_REEL,
      payload: { data: res.data?.reel },
    });
  } else {
    console.error(res.message);
  }
};

export const deleteFakeReel = (id) => async (dispatch) => {
  const res = await apiClient.delete(`reels/deleteFakeReel?reelId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_FAKE_REELS, payload: id });
  } else {
    console.error(res.message);
  }
};
